<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Vídeos' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content class="player-page">
  <ion-card class="video-card" *ngIf="video && video.config">
    <div class="player-container">
      <ng-container [ngSwitch]="video.config.plataforma">
        <video-player *ngSwitchCase="'youtube'" [id]="video.id" [video]="video.url" [autoPlay]="true"></video-player>

        <iframe *ngSwitchCase="'facebook'" [src]="video.url | facebook" width="100%" height="220" frameborder="0"
          scrolling="no" allowfullscreen></iframe>

        <iframe *ngSwitchCase="'vimeo'" [src]="video.url | vimeo" width="100%" height="220" frameborder="0"
          scrolling="no" allowfullscreen></iframe>
      </ng-container>
    </div>

    <ion-card-content>
      <h2 class="video-title">{{ video.nome }}</h2>
    </ion-card-content>
  </ion-card>

  <ion-list class="video-list">
    <ion-item button *ngFor="let v of videos" (click)="openVideo(v)" [class.active]="v.id === video.id" lines="none">
      <ion-avatar slot="start">
        <i class="fa-solid fa-circle-play" *ngIf="v.id !== video.id"></i>
        <i class="fa-solid fa-circle-pause playing" *ngIf="v.id === video.id"></i>
      </ion-avatar>

      <ion-label>
        <p>{{ v.nome }}</p>
      </ion-label>
    </ion-item>
  </ion-list>

  <ion-list *ngIf="videos.length === 0">
    <sem-registro></sem-registro>
  </ion-list>
</ion-content>